import React, { createContext, useContext, useState } from 'react';

interface LoadingContextType {
    loading: boolean;
    startLoading: () => void;
    stopLoading: () => void;
    moduleLoading: boolean;
    setModuleLoading: (value: boolean) => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const useLoading = () => {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error('useLoading must be used within a LoadingProvider');
    }
    return context;
};

interface LoadingProviderProps {
    children: React.ReactNode;
}

export const LoadingProvider: React.FC<LoadingProviderProps> = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [moduleLoading, setModuleLoading] = useState<boolean>(false);

    const startLoading = () => setLoading(true);
    const stopLoading = () => setLoading(false);

    const value: LoadingContextType = {
        loading,
        startLoading,
        stopLoading,
        moduleLoading,
        setModuleLoading
    };

    return (
        <LoadingContext.Provider value={value} >
            {children}
        </LoadingContext.Provider>
    );
};
